export const THIS_YEAR = 'this_year';
export const LAST_YEAR = 'last_year';
export const THIS_MONTH = 'this_month';
export const LAST_MONTH = 'last_month';
export const CUSTOM_PERIOD = 'custom_period';
